export default "__VITE_ASSET__C6aM3mc5__";